export default {
  computed: {
    itemsQuickFilters() {
      return {
        title: 'Items',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'item-reference-code',
                  label: this.$gettext('Reference Code'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'reference_code', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'item-description',
                  label: this.$gettext('Description'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'description', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'item-enabled',
                  label: this.$gettext('Item Status'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Enabled'),
                      value: 1
                    },
                    {
                      text: this.$gettext('Disabled'),
                      value: false
                    }
                  ],
                  value: null,
                  stacked: false,
                  callback: (val) => {
                    if (val === 1) {
                      return [[ 'active', 'eq', 1 ]]
                    } else if (val === false) {
                      return [[ 'active', 'eq', false ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'item-self-last-position-updated-age',
                  label: this.$gettext('Last Position Updated by Age'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: ''
                    },
                    {
                      text: this.$gettext('Last 36 hours'),
                      value: ['0 hours', '36 hours']
                    },
                    {
                      text: this.$gettext('Last 72 hours'),
                      value: ['36 hours', '72 hours']
                    },
                    {
                      text: this.$gettext('More than 72 hours'),
                      value: ['72 hours', '25 years']
                    }
                  ],
                  value: '',
                  stacked: false,
                  callback: (val) => {
                    if (val) {
                      let filter = [
                        [ 'last_position_updated_at', 'bt', [this.moment().subtract(val[1].split(' ')[0], val[1].split(' ')[1]).utc().format('YYYY-MM-DD HH:mm:ss'), this.moment().subtract(val[0].split(' ')[0], val[0].split(' ')[1]).utc().format('YYYY-MM-DD HH:mm:ss')] ]
                      ]
                      return filter
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'item-last-position-updated-at',
                  label: this.$gettext('Last Position Updated At Date Range'),
                  type: 'daterange',
                  opens: 'left',
                  showIf: () => this.ecosystemModules.items.geolocalizableBy && this.ecosystemModules.items.geolocalizableBy !== null,
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: false
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [[ 'last_position_updated_at', 'bt', range ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    },
    itemsShippingHistoryQuickFilters() {
      return {
        title: 'Items Shipping History',
        filters: {
          columns: [
            {
              class: 'col-12',
              filters: [
                {
                  name: 'item-shippings-status',
                  label: this.$gettext('Statuses'),
                  type: 'checkbox-group',
                  options: this.$appConfig.validStates,
                  value: [],
                  stacked: false,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'status', 'in', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-sm-4 col-lg-4',
              filters: [
                {
                  name: 'item-shippings-courier',
                  label: this.$gettext('Courier'),
                  type: 'user-autocomplete',
                  restrictToRoles: ['courier'],
                  placeholder: this.$gettext('Courier name or email'),
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      let couriers = val.map(function (item) {
                        return item.id
                      })
                      return [[ 'courier_id', 'in', couriers ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-sm-4 col-lg-4',
              filters: [
                {
                  name: 'item-shippings-created-at',
                  label: this.$gettext('Created At Date Range'),
                  type: 'daterange',
                  opens: 'right',
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: false
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [[ 'created_at', 'bt', range ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-sm-4 col-lg-4',
              filters: [
                {
                  name: 'item-shippings-updated-at',
                  label: this.$gettext('Updated At Date Range'),
                  type: 'daterange',
                  opens: 'left',
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: false
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [[ 'updated_at', 'bt', range ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    },
    itemsTrackingHistoryEventsQuickFilters() {
      return {
        title: 'Items Tracking History Events',
        filters: {
          columns: [
            {
              class: 'col-3',
              filters: [
                {
                  name: 'item-shippings-event-names',
                  label: this.$gettext('Events'),
                  type: 'checkbox-group',
                  options: [
                    {
                      text: this.$gettext('Entry'),
                      value: 'entry'
                    },
                    {
                      text: this.$gettext('Exit'),
                      value: 'exit'
                    },
                    {
                      text: this.$gettext('Picked Up'),
                      value: 'item_pickup'
                    },
                    {
                      text: this.$gettext('Dropped Off'),
                      value: 'item_dropoff'
                    }
                  ],
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'event_name', 'in', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-9',
              filters: [
                {
                  name: 'item-shippings-created-at',
                  label: this.$gettext('Event Date Range'),
                  type: 'daterange',
                  opens: 'right',
                  value: {
                    startDate: new Date(this.moment().subtract(6, 'day').startOf('day').format('YYYY-MM-DD')), // this.moment().subtract(7, 'days').toDate(),
                    endDate: new Date(this.moment().endOf('day').format('YYYY-MM-DD')), // this.moment().toDate(),
                    dateRangeActive: true
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [[ 'created_at', 'bt', range ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
